import affiliate from 'store/affiliate/affiliate.reducer';
import auth from 'store/auth/auth.reducer';
import content from 'store/content/content.reducer';
import markets from 'store/markets/markets.reducer';
import offers from 'store/offers/offers.reducer';
import profile from 'store/profile/profile.reducer';
import properties from 'store/properties/properties.reducer';
import reservations from 'store/reservations/reservations.reducer';
import target from 'store/target/target.reducer';
import ui from 'store/ui/ui.reducer';
import payments from 'store/payments/payments.reducer';

export default {
  content,
  properties,
  offers,
  markets,
  reservations,
  target,
  profile,
  auth,
  ui,
  affiliate,
  payments,
};
